import { MagicConfigMixin, formatCurrency, getFeatureEnabled, deviceChange, isTabletQuery, isDesktopQuery } from '@gig/magic-common';
import { Mixins, Prop, Watch, Component } from 'vue-property-decorator';
import { BALANCE_QUERY, Feature, BALANCE_UPDATED, BALANCE_CURRENCY_UPDATED } from '@gig/magic-messages';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
let Balance = class extends Mixins(MagicConfigMixin) {
  constructor() {
    super(...arguments);
    this.balance = null;
    this.currency = null;
    this.balanceLoading = false;
    this.isDesktop = false;
    this.isTablet = false;
    this.isTopNavigationEnabled = true;
    this.delayTimeout = null;
    this.balanceSubscription = null;
    this.currencySubscription = null;
    this.deviceSubscription = null;
  }
  created() {
    return __async(this, null, function* () {
      this.isTopNavigationEnabled = yield getFeatureEnabled(Feature.TOP_NAVIGATION);
      this.balanceSubscription = window.eventBus.subscribe(BALANCE_UPDATED, (event) => {
        const currentBalance = event.payload;
        this.clearTimer();
        if (this.balance && currentBalance && currentBalance.balance !== this.balance.balance) {
          this.balanceLoading = true;
          this.delayTimeout = setTimeout(() => {
            this.balanceLoading = false;
            this.balance = currentBalance;
          }, this.delay);
          return;
        }
        this.balance = currentBalance != null ? currentBalance : null;
      }, { replay: true });
      this.currencySubscription = window.eventBus.subscribe(BALANCE_CURRENCY_UPDATED, (e) => {
        this.currency = e.payload;
      }, { replay: true });
      this.deviceSubscription = deviceChange(() => __async(this, null, function* () {
        this.isTablet = yield isTabletQuery();
        this.isDesktop = yield isDesktopQuery();
      }));
    });
  }
  get realMoneyBalance() {
    if (this.balance === null) {
      return false;
    }
    const { realBalance, bonusRealMoneyBalance } = this.balance;
    return realBalance + bonusRealMoneyBalance;
  }
  hasExtraItem() {
    return this.$slots["extra-item"];
  }
  destroyed() {
    var _a, _b;
    this.clearTimer();
    if (this.balanceSubscription) {
      this.balanceSubscription.unsubscribe();
    }
    (_a = this.currencySubscription) == null ? void 0 : _a.unsubscribe();
    (_b = this.deviceSubscription) == null ? void 0 : _b.unsubscribe();
  }
  delayChanged() {
    return __async(this, null, function* () {
      var _a;
      if (this.delay === 0) {
        this.balance = (_a = yield window.queryBus.query(BALANCE_QUERY)) != null ? _a : null;
        this.balanceLoading = false;
      }
      this.clearTimer();
    });
  }
  clearTimer() {
    if (this.delayTimeout) {
      clearTimeout(this.delayTimeout);
    }
    this.balanceLoading = false;
  }
};
__decorateClass([
  Prop(Number)
], Balance.prototype, "delay", 2);
__decorateClass([
  Prop(Boolean)
], Balance.prototype, "compact", 2);
__decorateClass([
  Prop(Boolean)
], Balance.prototype, "gameplay", 2);
__decorateClass([
  Watch("delay")
], Balance.prototype, "delayChanged", 1);
Balance = __decorateClass([
  Component({
    name: "balance",
    filters: {
      formatCurrency
    }
  })
], Balance);

export default Balance;
